import { CardTemplate } from 'types/story';
import { CARD_DEFAULT_TEMPLATE_NAME } from 'common/constants';
import { defaultTemplate } from 'utils/facades/templates/default-template';
import { CardFacadeBase } from 'utils/facades/card-facade-base';

function _defaultTemplate(): CardTemplate {
	const template = defaultTemplate();
	template.editor.card.settings.showResults = true;
	return template;
}

class PollFacade extends CardFacadeBase {
	static template = {
		[CARD_DEFAULT_TEMPLATE_NAME]: _defaultTemplate,
	};
}

export { PollFacade };
